import { getDateLabel } from '@/lib/utils/dateLabel'

interface DateDividerProps {
  date: Date | string
}

export function DateDivider({ date }: DateDividerProps) {
  const label = getDateLabel(date)

  return (
    <div className="flex items-center gap-3 py-2">
      <div className="flex-1 h-px bg-white/[0.06]" />
      <span className="text-xs font-medium text-neutral-500 uppercase tracking-wider">
        {label}
      </span>
      <div className="flex-1 h-px bg-white/[0.06]" />
    </div>
  )
}
